 export class TrainDayCycle {
    trainCyclesNextTrainExceptionsUID: string;

    cycleUID: string;

    dayOfW: number;

    nextCycle: string;

    enabled: boolean;
 }

 export class TnTrainCyclesNextTrainException {
   trainCyclesNextTrainExceptionsUID: string;

   cycleUID: string;

   dayOfW: number;

   nextCycle: string;
 }

 export class TrainCycleDialogModel {
        cycleUID: string;

        name: string;

        nextName: string;

        nextCycleUID: string;

        overNightCycle: number;

        cycleExceptions: Array<TrainDayCycle>;

        tnTrainCycleExceptions: Array<TnTrainCyclesNextTrainException> = [];
    }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-cycle-dialog/train-cycle-dialog.model.ts